import { Box, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import {
  Bar,
  BarChart,
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  ReferenceLine,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';

interface Props {
  title?: string;
  lgNumber?: number;
  xsNumber?: number;
  tooltipText?: any;
  data?: any[];
  from?: string;
  dateInfo?: string;
  showValue?: boolean;
  showTooltip?: boolean;
  showStat?: boolean;
  rangeDate?: any;
  isToggle?: boolean;
  toggleType?: { type: string; value: 1 | 2 };
  onChangeToggle?: (type: string, newValue: 1 | 2) => void;
  loading?: boolean;
  labelTitle?: string[];
}

export const SwLineHasMultiSeriesChart: React.FC<Props> = ({
  title,
  lgNumber = 4,
  xsNumber = 6,
  tooltipText,
  data,
  from,
  dateInfo,
  showValue = true,
  showTooltip = true,
  showStat = false,
  rangeDate,
  toggleType,
  onChangeToggle,
  loading,
  labelTitle,
}) => {
  // Helper functions to calculate median and average
  const [lclData, setLclData] = useState<any[]>([]);
  const [median, setMedian] = useState<number>();
  const [average, setAverage] = useState<number>();
  const [stdDeviation, setStdDeviation] = useState<number>();

  const calculateMedian = (values: any[]) => {
    const newValues = [...values];
    const sortedData = newValues.sort((a: any, b: any) => a.value - b.value);
    const mid = Math.floor(sortedData.length / 2);
    return sortedData.length % 2 !== 0
      ? sortedData[mid].value
      : (sortedData[mid - 1].value + sortedData[mid].value) / 2;
  };

  const calculateAverage = (values: any[]) => {
    const newValues = [...values];
    const sortedData = newValues.sort((a: any, b: any) => a.value - b.value);
    let sum = 0;
    sortedData.map((d: any) => {
      sum += d.value;
    });
    return (sortedData.length ? sum / sortedData.length : 0).toFixed(1);
  };

  useEffect(() => {
    if (data !== undefined && data !== null && data.length > 0) {
      // 프로시져 수정 전에 쌓인 데이터중 v: 0 인 대상 삭제 처리
      const newData = data.filter((item: any) => item.value !== 0);
      setLclData(newData);
      if (newData === null || newData.length === 0) {
        return;
      }

      const a = 1;
      const newMedian = calculateMedian(newData);
      setMedian(newMedian);
      const newAverage = calculateAverage(newData);
      setAverage(Number(newAverage));

      let acc = 0;
      newData.map((d: any) => {
        acc += (d.value - Number(newAverage)) ** 2;
      });
      const variance = Math.sqrt(newData.length ? acc / newData.length : 0);
      setStdDeviation(Number(variance.toFixed(1)));
    } else {
      setLclData([]);
    }
  }, [data]);

  return (
    <>
      {lclData && lclData.length > 0 ? (
        <>
          <Typography sx={{ ml: '3.5rem' }} className='title'>
            중간값{' '}
            <span style={{ color: '#2581FF' }}>
              {median !== 0 ? median : '-'}
            </span>{' '}
            평균{' '}
            <span style={{ color: '#2581FF' }}>
              {average !== 0 ? average : '-'}
            </span>{' '}
            표준편차{' '}
            <span style={{ color: '#2581FF' }}>
              {median !== 0 && average !== 0 ? stdDeviation : '-'}
            </span>
          </Typography>
          <ResponsiveContainer width='100%' height='90%'>
            <LineChart
              width={500}
              height={400}
              margin={{
                top: 20,
                right: 20,
                bottom: 20,
                left: 20,
              }}
            >
              <CartesianGrid strokeDasharray='3 3' />
              <XAxis
                dataKey='value'
                label={{
                  value: labelTitle !== undefined ? labelTitle[0] : '',
                  position: 'insideBottom',
                  offset: -5,
                }}
              />
              <YAxis
                label={{
                  value: labelTitle !== undefined ? labelTitle[1] : '',
                  angle: -90,
                  position: 'insideLeft',
                  offset: 5,
                }}
              />
              <Tooltip />
              <Line dataKey='count' data={lclData} key='d' />
              {/* <ReferenceLine
          x={median}
          stroke='blue'
          label={{ position: 'insideBottom', value: `중간값 ${median}` }}
        />
        <ReferenceLine
          x={average}
          stroke='red'
          label={{ position: 'insideBottom', value: `평균 ${average}` }}
        /> */}
            </LineChart>
          </ResponsiveContainer>
        </>
      ) : (
        <Box
          className='no-data'
          sx={{ width: '100%', height: '100%', paddingTop: 0 }}
        >
          <div>데이터가 없습니다.</div>
        </Box>
      )}
    </>
  );
};
